let Content = (props) => {
  return <div className="pt-14 content min-w-0 flex-1 overflow-x-hidden">
    {props.children}
  </div>
}

export default Content;
